import { Routes } from '@angular/router';
import { AllSessionsComponent } from './components/all-sessions/all-sessions-component';
import { SessionSitesComponent } from './components/session-sites-component/session-sites-component';
import { NotFoundComponent } from './components/not-found-component/not-found-component';
import { ForbiddenComponent } from './components/forbidden-component/forbidden-component';
import { canActivateAuthRole } from './guards/access.guard';

export const routes: Routes = [
    {
        path: '',
        component: AllSessionsComponent,
        canActivate: [canActivateAuthRole],
    },
    {
        path: 'sessions',
        component: AllSessionsComponent,
        canActivate: [canActivateAuthRole],
    },
    {
        path: 'sessions/:code',
        component: SessionSitesComponent,
        canActivate: [canActivateAuthRole],
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        component: NotFoundComponent
    }
];
